module.exports = __webpack_public_path__ + "img/avatar_jia.72391314.png";